import {Component, OnInit} from '@angular/core';
import {
  AssistanceApplicationClient,
  PagedListOfAuditProgressReportTableRowViewModel
} from '../../../../services/api.client';
import {AuditReportUrls} from '../../../../api/AuditReportUrls';
import {FileDownloadService} from '../../../../services/FileDownloadService';
import {NotificationService} from '../../../../services/NotificationService';

@Component({
    selector: 'app-audit-progress-report',
    templateUrl: './audit-progress-report.component.html',
    styleUrls: ['./audit-progress-report.component.scss'],
    standalone: false
})
export class AuditProgressReportComponent implements OnInit {
  private pageIndex = 1;
  private limit = 10;
  private offset = 0;

  public pagedData: PagedListOfAuditProgressReportTableRowViewModel | undefined;
  public fetchingData = false;
  public activeOnly = true; // Default to checked

  constructor(private assistanceApplicationClient: AssistanceApplicationClient,
              private fileDownloadService: FileDownloadService,
              private _notificationService: NotificationService) {
  }

  ngOnInit(): void {
    this.fetchData();
  }
  private fetchData(): void {
    this.fetchingData = true;
    this.assistanceApplicationClient.getAuditProgressReportTableRows(
        this.limit,
        this.offset,
        undefined, // sortNameQuery
        undefined, // secondarySortQuery
        undefined, // descendingQuery
        this.activeOnly // activeOnly
    ).subscribe((data) => {
      this.pagedData = data;
      this.fetchingData = false;
    }, _err => {
      this.fetchingData = false;
      this._notificationService.showError('A problem occurred while retrieving data. Please try again.');
    });
  }
  public onExportClick(): void {
    const url = this.fileDownloadService.buildUrl(AuditReportUrls.DOWNLOAD_AUDIT_PROGRESS_REPORT, { activeOnly: this.activeOnly });
    window.open(url, '_blank');
  }

  public onPageChange(pageIndex: number): void {
    this.pageIndex = pageIndex;
    this.offset = (this.pageIndex - 1) * this.limit;
    this.fetchData();
  }

  public onLimitChange(limit: number): void {
    this.limit = limit;
    this.offset = (this.pageIndex - 1) * this.limit;
    this.fetchData();
  }

  public onActiveOnlyChange(activeOnly: boolean): void {
    this.activeOnly = activeOnly;
    this.pageIndex = 1; // Reset to first page when filtering
    this.offset = 0;
    this.fetchData();
  }
}
